// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDZvSlZd3JS6KVaBHRsYK0gOLvw98mCNms",
  authDomain: "rudo-manager-e7846.firebaseapp.com",
  projectId: "rudo-manager-e7846",
  storageBucket: "rudo-manager-e7846.firebasestorage.app",
  messagingSenderId: "587129028052",
  appId: "1:587129028052:web:a0d68227d0fc35fc926a41",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
